// @ts-nocheck
import React, { useLayoutEffect, useState } from "react";
import FormService, { StatusCodeToString } from "../services/formService";
import { NavigateFunction, Params, useNavigate, useParams } from "react-router-dom";
import { CoreDataGrid } from "../components/CoreDataGrid";
import { CoreButton } from "../components/CoreButton";
import { exportToExcel } from "../utils/excel";
import { FormStatus } from "../components/FormStatus";
import { downloadBlob } from "../services/download.service";
import AuthService from "../services/authService";
import { Loader } from "./Loader";


interface FormulariosProps {
  history: NavigateFunction,
  params: Readonly<Params<string>>
}

const StatusComponent = (props?: any) => {
  return (
    <FormStatus status={props.value} />
  )
}

const Formularios = ({ history, params }: FormulariosProps) => {

  const [selectedForms, setSelectedIndex] = useState<Form[]>([]);
  const [process, setProcess] = useState<{ running: boolean, status: string }>({ running: false, status: "" });
  const [status, setStatus] = useState("");


  const [forms, setForms] = useState<Form[]>([]);

  const handleOnSelect = (selectedList: Form[]) => {
    setSelectedIndex(selectedList);
  }

  const fetchForms = async () => {
    setProcess({ running: true, status: "Carregando formulários..." });
    let { data: fetchedForms } = await FormService.getForms() as Promise<Form[]>;
    fetchedForms = (fetchedForms as Form[]).map(f => {
      f._statusDescription = StatusCodeToString(f.status);
      return f;
    })
    setForms([...fetchedForms]);
    setProcess({ running: false, status: "" });

  }



  const handleExportExcel = () => {
    exportToExcel(selectedForms);
  }

  const handleExportTermo = async () => {
    if (selectedForms.length > 0) {

      let canEmitForms = selectedForms.filter(f => FormService.IsAllowedToEmit(f.status));
      console.log({ selectedForms, canEmitForms });

      for (const form of canEmitForms) {
        setProcess({ running: true, status: `Gerando termo para ${form.nomeCompleto}...` });

        let termoBlob = await FormService.getDownloadTermo(form.formId)
        downloadBlob(termoBlob, `${form.nomeCompleto.trim()}_${form.projetoNome.trim()}_termo.docx`);

      }

      setProcess({ running: false, status: "" });
    }


  }

  const handleDownloadDocuments = async () => {
    if (selectedForms.length > 0) {

      for (const form of selectedForms) {
        let stat = `Efetuando o download dos documentos do bolsista ${form.nomeCompleto}...`;
        setProcess({ running: true, status: stat });

        setStatus();
        let docName = `${form.nomeCompleto.trim()}_${form.projetoNome.trim()}_documento.pdf`;
        await FormService.downloadDocuments(form.formId, docName);
      }

      setProcess({ running: false });
    }
  }

  const handleClickRemove = async () => {
    let selected = selectedForms[0];
    console.log(selected)
    if (selected) {
      setProcess({ running: true, status: `Removendo formulário de ${selected.nomeCompleto}...` });
      await FormService.deleteForm(selected.formId);
      await fetchForms();

      setProcess({ running: false, status: "" });

    }
  }

  const handleClickEdit = () => {
    let selected = selectedForms[0];
    selected && history(`/gerenciamento/formularios/${selected.formId}`);

  }

  useLayoutEffect(() => {

    fetchForms();

  }, []);



  return (


    <div className="grid w-full grid-flow-row-dense">

      {
        process.running ?

          <Loader enabled status={process.status} />
          :
          <CoreDataGrid<Form>
            customActions={() => <>
              {!AuthService.isInRole(["Bolsista"]) && <CoreButton text="Excel" kind="normal" schema="success" disabled={selectedForms.length < 1 || process.running} onClick={handleExportExcel} />}
              {AuthService.isInRole(["FAEPI"]) && <CoreButton text="Termo" kind="normal" schema="info" disabled={selectedForms.length < 1 || process.running} onClick={handleExportTermo} />}
              <CoreButton text="Documentos" kind="normal" schema="info" disabled={selectedForms.length < 1 || process.running} onClick={handleDownloadDocuments} />
            </>
            }
            showNew={false}
            onSelected={handleOnSelect}
            onClickEdit={handleClickEdit}
            onClickRemove={handleClickRemove}
            items={forms}
            dictionary={{
              status: {
                header: "Status",
                template: (props: any) => <FormStatus status={props.value} />
              },
              _statusDescription: {
                header: "s",
                search: true,
                hidden: true
              },
              projetoNome: {
                search: true,
                header: "Projeto"
              },
              nomeCompleto: {
                search: true,
                header: "Bolsista"
              },
              instituicaoExecutora: {
                search: true,
                header: "Insituição"
              },
              modalidade: {
                search: true,
                header: "Modalidade"
              },
              cpf: {
                search: true,
                header: "CPF"
              }
            }}

          />
      }


    </div>

  );

}

// export default Formularios;
export default (props) => (
  <Formularios history={useNavigate()} params={useParams()} />
);
